import { render, staticRenderFns } from "./UjoUpload.vue?vue&type=template&id=59427836&scoped=true"
import script from "./UjoUpload.vue?vue&type=script&lang=js"
export * from "./UjoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59427836",
  null
  
)

export default component.exports